<template>
  <div class="video-list">
    <div class="no-data" v-show="videoList.length==0">
      <span>此条件暂无数据，请您尝试更换筛选条件</span>
    </div>

    <div @click="btnClick(item)" v-for="(item,index) of videoList" :key='index' class="video-item">
      <!-- 视频图片 -->
      <div class="video-img">
        <img v-if="item.coverPath" :src="item.coverPath" alt="">
        <img v-if="!item.coverPath" src="~@/assets/img/cloudClassCenter/defaultImg.png" alt="">
      </div>
      <!-- 视频简介 -->
      <div class="video-title">
        {{item.courseTitle}}
      </div>

      <!-- 老师学校 -->
      <div class="video-school">
        <span class="video-school-name">{{item.schoolName}}</span>
        <span class="video-school-line">|</span>
        <span class="video-school-lecturer">{{item.lecturerName}}</span>
      </div>

      <!-- 学习人数 -->
      <div class="video-people">

        <!-- 收藏人数 -->
        <span class="video-people-num" v-if="item.state=='1'||item.state=='3'">{{item.enshrine}}</span>
        <!-- 报名人数 -->
        <span class="video-people-num" v-if="item.state=='0'">{{item.registerFor}}</span>
        <!-- 直播人数 -->
        <span class="video-people-num" v-if="item.num">{{item.num}}</span>

        <!-- 未开始 -->
        <span v-if="item.state=='0'">人在报名</span>
        <!-- 在直播 -->
        <span v-if="item.state=='1'||item.num">人在学习</span>
        <!-- 已结束 -->
        <span v-if="item.state=='3'">人已学习</span>
      </div>

      <!--顶部展示 是否在直播或者已经直播结束 	课堂类型：0 = 1+N，1 = 直播，2 = 点播 状态（0.未开始 1.进行中 2.下课中 3.已结束） -->
      <div v-if="item.type!=2" class="video-state">

        <div v-if="item.state == '1'" class="play">
          <img src="~@/assets/img/cloudClassCenter/download.gif" alt="">
          <span>直播中</span>
        </div>
        <div v-if="item.state=='3'" class="finish">
          已结束
        </div>
      </div>

      <!-- 底部展示 是否有回放还是报名中 -->
      <div v-if="item.type!=2" class="play-back-apply">
        <div v-if="LookBack&&item.state==3" class="play-back">
          <img width="15px" src="~@/assets/img/cloudClassCenter/shipin.png" alt="">
          观看回放
        </div>

        <div v-if="item.state==0" class="apply">
          报名中
        </div>

        <div v-if="item.state==2" class="apply">
          下课中
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { intoCloudClass } from "@/network/cloudRequest/api";
export default {
  name: "VideoList",
  props: {
    videoList: {
      type: Array
    }
  },
  data() {
    return {
      //是否存在回放
      isLookBack: false
    };
  },

  computed: {
    LookBack() {
      //检查是否存在回放--------------------------------------------
      intoCloudClass(this.videoList[0].cloudClassId).then(res => {
        if (res.data.success) {
          this.isLookBack = !(res.data.data.videoList.length == 0);
        }
      });
      return this.isLookBack;
    }
  },

  methods: {
    btnClick(item) {
      this.$router.push({
        name: "VideoPage",
        query: { cloudClassId: item.cloudClassId }
      });
    }
  }
};
</script>

<style lang='less' scoped>
@width: 215px;

.video-list {
  display: flex;

  margin: 0 auto;
  padding-top: 20px;

  flex-wrap: wrap;

  .no-data {
    margin: 50px auto;

    font-size: 20px;

    color: #24ba58;

    user-select: none;
  }

  .video-item:hover {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

    transform: translate3d(0, -2px, 0);
  }

  .video-item {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    position: relative;

    margin-bottom: 20px;
    margin-left: 20px;
    border-radius: 5px;
    width: @width;
    height: 190px;

    font-size: 12px;

    color: #878787;
    background-color: #fff;

    cursor: pointer;

    .video-img {
      width: @width;
      height: 120px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .video-title {
      overflow: hidden;

      padding: 5px 0 5px 10px;
      width: @width;

      font-size: 13px;
      line-height: 13px;
      text-overflow: ellipsis;

      color: #000;
    }

    .video-school {
      overflow: hidden;

      padding: 0 0 5px 10px;
      width: @width;

      .video-school-line {
        margin: 0 4px;
      }
    }

    .video-people {
      overflow: hidden;

      padding-left: 10px;
      width: @width;
      .video-people-num {
        color: #24ba58;
      }
    }

    .video-state {
      overflow: hidden;

      position: absolute;
      top: 0;
      left: 0;

      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;

      line-height: 22px;

      color: #fff;

      .play {
        display: flex;

        border-radius: 2px;
        padding: 0 4px;
        width: 70px;
        height: 22px;

        background-color: rgba(0, 0, 0, 0.5);

        align-items: center;
      }

      .finish {
        width: 60px;
        height: 22px;

        text-align: center;

        background-color: #f35f7b;
      }
    }

    .play-back-apply {
      overflow: hidden;

      position: absolute;
      right: 0;
      bottom: 0;

      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;
      width: 75px;
      height: 22px;

      line-height: 22px;
      text-align: center;

      color: #fff;

      .play-back {
        display: flex;

        background-color: #f35f7b;

        align-items: center;
        justify-content: center;

        img {
          margin-right: 3px;
        }
      }

      .apply {
        background-color: #29c77b;
      }
    }
  }
}
</style>